// extracted by mini-css-extract-plugin
export var component = "KeywordTags-module--component--b3f64";
export var fadePop = "KeywordTags-module--fade-pop--88c6b";
export var growHeightIn = "KeywordTags-module--grow-height-in--63312";
export var label = "KeywordTags-module--label--f2982";
export var tagsCategoryRow = "KeywordTags-module--tagsCategoryRow--cab5b";